import MigrationMessagingBanner from 'ui-addon-conversations-settings/help-desk-migration/components/MigrationMessagingBanner';
import { useConnectedFormByChannelInstanceId } from 'ui-addon-conversations-settings/help-desk-migration/hooks/useConnectedForm';
import { getEmailOrFormMigrationStatusUrl } from '../../../urls/getHelpDeskMigrationUrl';
import { jsx as _jsx } from "react/jsx-runtime";
const FormMigrationBanner = ({
  channel,
  inboxId
}) => {
  const {
    channelInstanceId
  } = channel;
  const {
    connectedForm
  } = useConnectedFormByChannelInstanceId(channelInstanceId);
  if (!connectedForm) {
    return null;
  }
  return /*#__PURE__*/_jsx(MigrationMessagingBanner, {
    channel: channel,
    viewStatusRoute: getEmailOrFormMigrationStatusUrl(inboxId, 'forms', connectedForm.id)
  });
};
FormMigrationBanner.displayName = 'FormMigrationBanner';
export default FormMigrationBanner;